/* Cart feature chunk. Loaded only on commerce pages or first cart interaction. */
function btyUpdateProgressBarCart( cartTotal, itemCount  ) {
	const progressWrapper = document.getElementById( 'cart-progress-wrapper' );

	if ( ! progressWrapper ) {
		return;
	}

	const moneyFormat            = progressWrapper.dataset.moneyFormat;
	const preGoalMessageTemplate = progressWrapper.dataset.preGoalMessageTemplate;
	const postGoalMessage        = progressWrapper.dataset.postGoalMessage;

	const progressBar        = document.getElementById( 'cart-progress-bar' );
	const goalMessageElement = document.querySelector( '.goal-message' );

	let progressThreshold = Math.round(progressWrapper.dataset.threshold * (Shopify.currency.rate || 1));

	if ( ! moneyFormat || ! progressThreshold || ! preGoalMessageTemplate || ! postGoalMessage || ! progressBar || ! goalMessageElement ) {
		return;
	}

	if ( itemCount === 0 || cartTotal === 0 ) {
		if ( progressWrapper ) {
			progressWrapper.style.display = 'none';
		}
		if ( goalMessageElement ) {
			goalMessageElement.style.display = 'none';
		}
	} else {
		if ( progressWrapper ) {
			progressWrapper.style.display = 'block';
			progressWrapper.setAttribute( 'data-threshold-selected-currency', progressThreshold );
		}

		if ( progressBar ) {
			progressBar.style.display = 'block';

			let progressPercentage = null;

			// console.log( cartTotal );

			if ( cartTotal ) {
				progressPercentage = Math.min( ( cartTotal / progressThreshold ) * 100, 100 );
			} else {
				let sideCartPrice = document.querySelector( '.side-cart-footer .total-price' );
				if ( sideCartPrice ) {
					let total_price_str    = sideCartPrice.textContent.replace( /\D/g,'' ),
						total_price_number = Number( total_price_str );

					if ( moneyFormat.includes( '{{amount_no_decimals}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_comma_separator}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_space_separator}}' ) ) {
						progressPercentage = Math.min( ( total_price_number * 100 / progressThreshold ) * 100, 100 );
					} else {
						progressPercentage = Math.min( ( total_price_number / progressThreshold ) * 100, 100 );
					}
				}

				let mainCartPrice = document.querySelector( '.cart-page-section .cart-totals .totals-price' );
				if ( mainCartPrice ) {
					let total_price_str    = mainCartPrice.textContent.replace( /\D/g,'' ),
						total_price_number = Number( total_price_str );

					if ( moneyFormat.includes( '{{amount_no_decimals}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_comma_separator}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_space_separator}}' ) ) {
						progressPercentage = Math.min( ( total_price_number * 100 / progressThreshold ) * 100, 100 );
					} else {
						progressPercentage = Math.min( ( total_price_number / progressThreshold ) * 100, 100 );
					}
				}
			}

			progressBar.style.width = `${progressPercentage}%`;

			if ( progressPercentage >= 100 ) {
				progressWrapper.classList.add( 'full' );
			} else {
				progressWrapper.classList.remove( 'full' );
			}
		}

		if ( goalMessageElement ) {
			goalMessageElement.style.display = 'block';

			let remainingForGoal = null;

			if ( cartTotal ) {
				remainingForGoal = progressThreshold - cartTotal;
			} else {
				let sideCartPrice = document.querySelector( '.side-cart-footer .total-price' );
				if ( sideCartPrice ) {
					let total_price_str    = sideCartPrice.textContent.replace( /\D/g,'' ),
						total_price_number = Number( total_price_str );

					if ( moneyFormat.includes( '{{amount_no_decimals}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_comma_separator}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_space_separator}}' ) ) {
						remainingForGoal = progressThreshold - Math.min( total_price_number * 100 );
					} else {
						remainingForGoal = progressThreshold - total_price_number;
					}
				}

				let mainCartPrice = document.querySelector( '.cart-page-section .cart-totals .totals-price' );
				if ( mainCartPrice ) {
					let total_price_str    = mainCartPrice.textContent.replace( /\D/g,'' ),
						total_price_number = Number( total_price_str );

					if ( moneyFormat.includes( '{{amount_no_decimals}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_comma_separator}}' ) || moneyFormat.includes( '{{amount_no_decimals_with_space_separator}}' ) ) {
						remainingForGoal = progressThreshold - Math.min( total_price_number * 100 );
					} else {
						remainingForGoal = progressThreshold - total_price_number;
					}
				}
			}

			if ( remainingForGoal < 0 ) {
				remainingForGoal = 0;
			}

			let remainingAmount = remainingForGoal;

			let remainingAmountFormatted = btyFormatPrice(remainingAmount);
			let shippingStatus = document.querySelector( '[data-cart-shipping-status]' );

			if ( shippingStatus ) {
				let spendTemplate = shippingStatus.dataset.spendTemplate || 'Spend [remaining] for free shipping',
					freeLabel    = shippingStatus.dataset.freeLabel || 'Free';

				shippingStatus.textContent = remainingForGoal > 0
					? spendTemplate.replace( '[remaining]', remainingAmountFormatted )
					: freeLabel;
			}

			const preGoalMessage = preGoalMessageTemplate.replace( '[remainingForGoalFormatted]', remainingAmountFormatted );

			goalMessageElement.innerHTML = remainingForGoal > 0 ? preGoalMessage : postGoalMessage;
		}
	}
}

function btyMinicartRecommendations( doc = document ) {
	let selector = doc.querySelector( '.minicart-recommendations[data-source]' );
	if ( ! selector ) {
		return;
	}

	let url = selector.getAttribute( 'data-url' );

	if ( selector.innerHTML.trim() || ! url ) {
		return;
	}

	fetch( url )
		.then(
			function( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function( res ) {
				selector.innerHTML = btyGetSectionHtml( res, '.minicart-recommendations[data-source]' );

				btyAddToCart( selector );
				btyQuickView( selector );
				btySwatch( selector );
				btyAnimationImageLoad( selector );
				btyHoverMediaVideo( selector );
				btyQuickAdd( selector );
				btyScrollAnimationTrigger( selector );

				// Fire when product card updated.
				document.dispatchEvent( new CustomEvent( 'product-card-updated' ) );
			}
		).catch(
			function( err ) {
				console.log( err );
			}
		);
}

function btySideCartPopupOuter( doc = document ) {
	let selector = doc.querySelector( '.side-cart-inner' ),
		overlay  = selector ? selector.querySelector( '.mini-cart-overlay' ) : false,
		popup    = selector ? selector.querySelectorAll( '.popup-toolDown' ) : false;

	if ( ! popup.length || ! overlay) {
		return;
	}

	popup.forEach(
		function( el ) {
			selector.addEventListener(
				'mousedown',
				function( e ) {
					if ( ! el.contains( e.target ) ) {
						if ( el.classList.contains( 'open' ) && overlay.classList.contains( 'open' ) ) {
							el.classList.remove( "open" );
							overlay.classList.remove( "open" );
						}
					}
				}
			);
		}
	);
}

function btyAgreeToTerms( doc = document ) {
	let selector = document.querySelectorAll( '.agree-to-terms' );

	if ( ! selector.length ) {
		return;
	}

	selector.forEach(
		function( el ) {
			let agreeCheckbox = el.querySelector( '#agree' );
			let checkoutButton = el.parentNode.querySelector( 'button[name="checkout"]' );

			if ( ! agreeCheckbox || ! checkoutButton ) {
				return;
			}

			// Disable the checkout button initially
			checkoutButton.disabled = true;

			agreeCheckbox.addEventListener('change', function() {
				checkoutButton.disabled = !this.checked;
			});
		}
	);
}

function btyUpdateDiscountSideCartItem( doc = document ) {
	let item = doc.querySelectorAll( '.side-cart .product-item[data-id]' );
	if ( ! item.length ) {
		return;
	}

	// Register dom html need an update when the response available.
	let modules = [
		{
			node: '.side-cart .cart-items',
			section: 'side-cart',
			selector: '.side-cart .cart-items'
		},
		{
			node: '.side-cart .sub-total',
			section: 'side-cart',
			selector: '.side-cart .sub-total'
		}
	];

	item.forEach(
		function( el ) {
			let id = el.getAttribute( 'data-id' );

			if ( ! id ) {
				return;
			}

			let discountApplyButton = el.closest( '.side-cart' ).querySelector( '.side-cart-footer [data-update-coupon]' );

			if ( ! discountApplyButton ) {
				return;
			}

			discountApplyButton.onclick = function() {
				let inputs  = el.querySelectorAll( '.quantity-input' );

				if ( inputs.length ) {
					inputs.forEach(
						function( input ) {
							let data;

							data = {
								id: id,
								sections: modules.map( (s) => s.section ),
								sections_url: window.location.pathname
							}

							// Fetch data.
							setTimeout(() => {
								btyFetchCart( data, modules, el );
							}, "500");
						}
					);
				}
			}
		}
	);
}

function btyCartItemCount( items = 1 ) {
	let count = document.querySelectorAll( '.cart-item-count' ),
		label = document.querySelectorAll( '.item-count-label' );
	if ( ! count.length ) {
		return;
	}

	items = Number( items );

	count.forEach(
		function( el ) {
			el.innerHTML = items;

			if ( items < 1 ) {
				el.classList.add( 'hidden' );
			} else {
				el.classList.remove( 'hidden' );
			}
		}
	);

	label.forEach(
		function( el ) {
			if (typeof window.cartText !== 'undefined') {
				el.textContent = items === 1 ? window.cartText.one : window.cartText.other;
			} else {
				el.textContent = items === 1 ? 'item' : 'items';
			}
		}
	);
}

function btyGetCartSectionElement( sectionHtml, selector ) {
	if ( typeof sectionHtml !== 'string' || ! sectionHtml.trim() ) {
		return null;
	}

	return new DOMParser().parseFromString( sectionHtml, 'text/html' ).querySelector( selector );
}

function btyGetCartSectionHtml( sectionHtml, selector ) {
	let element = btyGetCartSectionElement( sectionHtml, selector );
	return element ? element.innerHTML : null;
}

function btyReinitCartDrawer( root = document ) {
	btyQuantityButton( root );
	btyUpdateProductQuantity( root );
	btyAnimationImageLoad( root );
	btyScrollAnimationTrigger( root );
	btyMinicartRecommendations( root );
	btySideCartPopupOuter( root );
	btyAgreeToTerms( root );
}

function btyFetchFreshCartSections() {
	let body = JSON.stringify( {
		sections: [ 'side-cart', 'cart-count' ],
		sections_url: btyGlobals.cart_url
	} );

	return fetch( btyGlobals.cart_update_url, {
		...btyFetchConfig(),
		credentials: 'same-origin',
		cache: 'no-store',
		body
	} )
		.then(
			function( response ) {
				if ( ! response.ok ) {
					throw new Error( 'Cart sections update failed: ' + response.status );
				}

				return response.json();
			}
		)
		.then(
			function( cart ) {
				return cart.sections || {};
			}
		);
}

function btyUpdateCartModules( sections, modules ) {
	modules.forEach(
		function( mod ) {
			if ( ! mod.node || ! mod.selector ) {
				return;
			}

			let sectionHtml = sections ? sections[mod.section] : '',
				sourceHtml  = btyGetCartSectionHtml( sectionHtml, mod.selector );

			if ( sourceHtml === null ) {
				return;
			}

			document.querySelectorAll( mod.node ).forEach(
				function( el ) {
					el.innerHTML = sourceHtml;
				}
			);
		}
	);

	btyAddToCart();
	btySwatch();
	btyQuickAdd();
}

function btyFetchCart( obj, modules, item ) {
	let body = JSON.stringify( obj );

	fetch( btyGlobals.cart_change_url, {...btyFetchConfig(), ...{ body } } )
		.then(
			function( r ) {
				return r.json();
			}
		).then(
			function( res ) {
				let warning = item.querySelectorAll( '.product-warning' );
				if ( warning.length ) {
					warning.forEach(
						function( el ) {
							el.innerHTML = '';
						}
					);
				}

				if ( res.errors && warning.length ) {
					warning.forEach(
						function( el ) {
							el.innerHTML = btyGlobals.svg_warning + res.errors;
						}
					);

					let qtyInput = item.querySelectorAll( '.quantity-input' );
					if ( qtyInput.length ) {
						qtyInput.forEach(
							function( el ) {
								el.value = el.getAttribute( 'data-qty' );
							}
						);
					}

					return;
				}

				// Update cart item count first.
				btyCartItemCount( res.item_count );

				// Cart empty.
				if ( ! res.items.length ) {
					let cartTable       = document.querySelector( '.cart-page-section .container' ),
						cartSubtotal    = cartTable ? cartTable.querySelector( '.cart-footer' ) : false,
						sideCartContent = document.querySelector( '.side-cart-content' ),
						sideCartFooter  = document.querySelector( '.side-cart-footer' );

					// Update cart table section.
					if ( cartTable ) {
						let cartTableHtml = btyGetCartSectionHtml( res.sections['main-cart'], '.container' );
						if ( cartTableHtml !== null ) {
							cartTable.innerHTML = cartTableHtml;
						}
					}

					// Remove cart subtotal section.
					if ( cartSubtotal ) {
						cartSubtotal.remove();
					}

					// Update side cart content.
					if ( sideCartContent ) {
						let sideCartContentHtml = btyGetCartSectionHtml( res.sections['side-cart'], '.side-cart-content' );
						if ( sideCartContentHtml !== null ) {
							sideCartContent.innerHTML = sideCartContentHtml;
						}
					}

					// Remove side cart footer.
					if ( sideCartFooter ) {
						sideCartFooter.remove();
					}

					// Open login popup when cart empty.
					btyAccountPopup();
				}

				// Update current item.
				let currentItem = res.items.filter( (e) => e.line === Number( obj.line ) );
				if ( currentItem.length ) {
					let sidecartContent = item.closest( '.side-cart-content' ),
						totalPrice      = item.querySelector( '.totals-item-price' ),
						quantityUnit    = item.querySelectorAll( '[name="quantity"]' );
					if ( totalPrice ) {
						let totalPriceHtml = btyGetCartSectionHtml( res.sections['main-cart'], '[data-line="' + obj.line + '"] .totals-item-price' );
						if ( totalPriceHtml !== null ) {
							totalPrice.innerHTML = totalPriceHtml;
						}
					}

					if ( sidecartContent ) {
						let itemHtml = btyGetCartSectionHtml( res.sections['side-cart'], '[data-line="' + obj.line + '"]' );
						if ( itemHtml !== null ) {
							item.innerHTML = itemHtml;
						}
					}

					if ( quantityUnit.length ) {
						quantityUnit.forEach(
							function( el ) {
								el.setAttribute( 'data-qty', obj.quantity );
							}
						);
					}
				} else {
					item.remove();
				}

				btyUpdateCartModules( res.sections, modules );
				btyUpdateProgressBarCart( res.total_price, res.item_count );
				btyReinitCartDrawer();
			}
		).catch(
			function( e ) {
				console.error( e );
			}
		).finally(
			function() {
				// Remove loading.
				item.classList.remove( 'updating' );
			}
		);
}

function btyUpdateProductQuantity( doc = document ) {
	let item = doc.querySelectorAll( '.product-item[data-line]' );
	if ( ! item.length ) {
		return;
	}

	// Register dom html need an update when the response available.
	let modules = [
		{
			node: '.cart-totals',
			section: 'main-cart',
			selector: '.cart-totals'
	},
		{
			node: '.agree-to-terms',
			section: 'main-cart',
			selector: '.agree-to-terms'
	},
		{
			node: '.cart-table',
			section: 'main-cart',
			selector: '.cart-table'
	},
		{
			node: '.cart-items',
			section: 'side-cart',
			selector: '.cart-items'
	},
		{
			node: '.minicart-recommendations-wrapper',
			section: 'side-cart',
			selector: '.minicart-recommendations-wrapper'
	},
	{
		node: '.side-cart-footer .cart-summary',
		section: 'side-cart',
		selector: '.side-cart-footer .cart-summary'
	},
		{
			node: '.side-cart .agree-to-terms',
			section: 'side-cart',
			selector: '.side-cart .agree-to-terms'
	}
	];

	item.forEach(
		function( el ) {
			let line = parseInt( el.getAttribute( 'data-line' ), 10 );

			if ( ! line || isNaN( line ) ) {
				return;
			}

			let removes = el.querySelectorAll( '.product-remove' ),
				inputs  = el.querySelectorAll( '.quantity-input' );

			// Quantity change.
			if ( inputs.length ) {
				inputs.forEach(
					function( input ) {
						input.onchange = function() {
							let data, quantity = Number( input.value.trim() );

							// Loading effect.
							el.classList.add( 'updating' );

							data = {
								line: line,
								quantity: quantity,
								sections: modules.map( (s) => s.section ),
								sections_url: window.location.pathname
							}

							// Fetch data.
							btyFetchCart( data, modules, el );
						}
					}
				);
			}

			// Remove button click.
			if ( removes.length ) {
				removes.forEach(
					function( remove ) {
						remove.onclick = function( e ) {
							e.preventDefault();

							// Loading effect.
							el.classList.add( 'updating' );

							let data = {
								line: line,
								quantity: 0,
								sections: modules.map( (s) => s.section ),
								sections_url: window.location.pathname
							}

							// Fetch data.
							btyFetchCart( data, modules, el );
						}
					}
				);
			}
		}
	);
}

function btyOpenActiveCart() {
	let sideCart = document.querySelector( '.side-cart' );
	if ( ! sideCart ) {
		if ( document.querySelector( '.ocu-cart-drawer' ) ) {
			window.dispatchEvent( new CustomEvent( 'ocu:cart:open' ) );
		}

		return;
	}

	document.documentElement.classList.add( 'side-cart-open' );
	btyClosePopup( 'side-cart-open', sideCart );

	const closeBtn = sideCart.querySelector( '.side-cart-close' );
	if ( closeBtn ) {
		setTimeout( () => closeBtn.focus(), 300 );
	}

	if ( sideCart._trap ) {
		return;
	}

	sideCart._trap = true;
	sideCart.addEventListener(
		'keydown',
		function( event ) {
			if ( event.key !== 'Tab' ) {
				return;
			}

			const elements = sideCart.querySelectorAll(
				'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])'
			);
			const first = elements[0];
			const last  = elements[elements.length - 1];

			if ( ! first || ! last ) {
				return;
			}

			if ( event.shiftKey && document.activeElement === first ) {
				event.preventDefault();
				last.focus();
			} else if ( ! event.shiftKey && document.activeElement === last ) {
				event.preventDefault();
				first.focus();
			}
		}
	);
}

function btySideCart() {
	if ( document.documentElement.dataset.sideCartTriggerBound === 'true' ) {
		return;
	}

	document.documentElement.dataset.sideCartTriggerBound = 'true';

	document.addEventListener(
		'click',
		function( e ) {
			let trigger = e.target.closest( '.action-cart' );
			if ( ! trigger ) {
				return;
			}

			e.preventDefault();
			e.stopImmediatePropagation();
			btyOpenActiveCart();
		},
		true
	);
}

function btyFetchConfig( type = 'json' ) {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/' + type
		}
	};
}

function btyShowCartAddError(message) {
	let notice = document.querySelector('.cart-add-feedback');
	if (!notice) {
		notice = document.createElement('div');
		notice.className = 'cart-add-feedback';
		notice.setAttribute('role', 'alert');
		document.body.appendChild(notice);
	}

	window.clearTimeout(notice.hideTimer);
	notice.textContent = String(message || btyStrings.cart.error || 'Unable to add this item to the cart.');
	notice.classList.add('is-visible');
	notice.hideTimer = window.setTimeout(() => {
		notice.classList.remove('is-visible');
	}, 7000);
}

function btyAddToCart(doc = document) {
	let buttons = doc.querySelectorAll('.add-to-cart-button');
	if (!buttons.length) return;

	let modules = [
		{
			node: '.side-cart-inner',
			section: 'side-cart',
			selector: '.side-cart-inner'
		},
		{
			section: 'cart-count'
		}
	];

	buttons.forEach(function (button) {
		// Hidden payment button if require selling plan.
		if (button.classList.contains('selling-plan-error')) {
			let formEl = button.closest('[data-type="add-to-cart-form"]');
			if (formEl) {
				let paymentButton = formEl.querySelector('.shopify-payment-button');
				if (paymentButton) paymentButton.classList.add('hidden');
			}
		}

		let handleAddToThemeCart = function (e) {
			// Keep third-party cart drawers from handling the same Add to cart click.
			e.stopPropagation();

			let form = button.closest('[data-type="add-to-cart-form"]');

			// Ignore repeated clicks while the current cart request is still running.
			if (button.classList.contains('loading')) {
				e.preventDefault();
				return;
			}

			// Check selling plan
			if (button.classList.contains('selling-plan-error')) {
				if (form) {
					let sellingMessage = form.parentNode?.querySelector('.selling-plan-message');
					if (sellingMessage) {
						sellingMessage.innerHTML = btyStrings.product.selling_plan_message;
						sellingMessage.classList.remove('hidden');
					}
				}
				e.preventDefault();
				return;
			}

			let sideCartNode = document.querySelector('.side-cart');
			if (sideCartNode) sideCartNode._lastFocused = document.activeElement;

			if (button.classList.contains('disabled')) {
				e.preventDefault();
				return;
			}

			if (button.tagName.toUpperCase() === 'A') return;
			e.preventDefault();

			if (
				button.classList.contains('add-product-variants') &&
				window.matchMedia('(max-width: 767px)').matches
			) {
				return;
			}

			button.classList.add('loading');
			button.setAttribute('aria-busy', 'true');
			let mobileAddButton = button.closest('.product-card')?.querySelector('.product-card__mobile-add');
			if (mobileAddButton) {
				mobileAddButton.classList.add('loading');
				mobileAddButton.setAttribute('aria-busy', 'true');
			}
			const clearLoading = () => {
				button.classList.remove('loading');
				button.removeAttribute('aria-busy');
				window.clearTimeout(mobileAddButton?.cartLoadingFallback);
				mobileAddButton?.classList.remove('loading');
				mobileAddButton?.removeAttribute('aria-busy');
			};

			if (!form) {
				clearLoading();
				return;
			}

			let formData = new FormData(form),
				warning = form.parentNode.querySelector('.product-warning'),
				config = btyFetchConfig('javascript');

			let qtyInput = form.querySelector('input[name="quantity"]');
			let max = parseInt(qtyInput?.getAttribute('max') || 0);
			let val = parseInt(qtyInput?.value || 1);

			// Validate.
			if (max && val > max) {
				const msg = btyStrings.product.warning_message.replace('{{max}}', max);
				if (warning) {
					warning.innerHTML = btyGlobals.svg_warning + msg;
					warning.classList.remove('hidden');
				}
				btyShowCartAddError(msg);

				qtyInput.value = max;
				clearLoading();
				return;
			}


			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			formData.append('sections', modules.map((s) => s.section));
			formData.append('sections_url', btyGlobals.cart_url);
			config.body = formData;

			fetch(btyGlobals.cart_add_url, config)
				.then((r) => r.json())
				.then((res) => {
					const errorMessage = res.description || res.message || btyStrings.cart.error;
					if (warning) {
						warning.innerHTML = res.status
							? btyGlobals.svg_warning + errorMessage
							: '';
					}

					if (res.status) {
						btyShowCartAddError(errorMessage);
						return;
					}

					if (res.sections && res.sections['cart-count']) {
						btyCartItemCount(
							btyGetSectionHtml(res.sections['cart-count'], '.shopify-section')
						);
					}

					return btyFetchFreshCartSections().then((sections) => {
						btyUpdateCartModules(sections, modules);
						if (sections && sections['cart-count']) {
							btyCartItemCount(
								btyGetSectionHtml(sections['cart-count'], '.shopify-section')
							);
						}
						btyReinitCartDrawer();
						setTimeout( btyOpenActiveCart );
						btyUpdateProgressBarCart();
					});
				})
				.catch((e) => {
					console.error(e);
					btyShowCartAddError(btyStrings.cart.error);
				})
				.finally(() => {
					clearLoading();
					btyQuantityButton();
					btyUpdateProductQuantity();

					let quickAddLoading = doc.querySelector('.quick-add-box .field-item.loading');
					if (quickAddLoading) quickAddLoading.classList.remove('loading');

					document.documentElement.classList.remove('quick-view-open');

					btyAgreeToTerms();
				});
		};

		button.onclick = handleAddToThemeCart;

		if (
			button.classList.contains( 'sticky-add-to-cart-button' )
			&& button.dataset.themeCartTouch !== 'true'
		) {
			let touchStart = false;

			button.dataset.themeCartTouch = 'true';
			button.addEventListener(
				'touchstart',
				function( event ) {
					if ( event.touches.length !== 1 ) {
						touchStart = false;
						return;
					}

					touchStart = {
						x: event.touches[ 0 ].clientX,
						y: event.touches[ 0 ].clientY
					};
				},
				{ passive: true }
			);

			button.addEventListener(
				'touchend',
				function( event ) {
					let touch = event.changedTouches[ 0 ];

					if ( ! touchStart || ! touch ) {
						touchStart = false;
						return;
					}

					let moved = Math.max(
						Math.abs( touch.clientX - touchStart.x ),
						Math.abs( touch.clientY - touchStart.y )
					);

					touchStart = false;

					if ( moved > 12 ) {
						return;
					}

					event.preventDefault();
					event.stopImmediatePropagation();

					if ( typeof button.btySyncMainProductForm === 'function' ) {
						button.btySyncMainProductForm();
					}

					handleAddToThemeCart( event );
				},
				{ passive: false }
			);

			button.addEventListener( 'touchcancel', function() {
				touchStart = false;
			} );
		}
	});
}

function btyAddMultiProductToCart(doc = document) {
	let selectors = doc.querySelectorAll('.add-multiple-products');
	if (!selectors.length) return;

	selectors.forEach(function (el) {
		let items = el.parentNode.querySelectorAll('.product-card [name="id"]');
		if (!items.length) return;

		items.forEach(function (item, index) {
			item.addEventListener('change', function () {
				let currentId = el.querySelector('[data-index="' + index + '"]');
				if (currentId) currentId.value = item.value;
			});
		});
	});
}
